import './style.css';

export interface ButtonProps {
    title: string;   
    onClick?: () => void;
    disabled?: boolean;
}

function SecondaryButton({ title, onClick, disabled = false }: ButtonProps) {
    return (
        <div className="container_secondary-button">
            <button type="button" className="container_button__secondary" disabled={disabled} onClick={onClick}>{title}</button>
        </div>
    )
} 

export default SecondaryButton;
